import moment from 'moment';
import Chart from 'chart.js/auto'
import zoomPlugin from 'chartjs-plugin-zoom';
import { FunnelController, TrapezoidElement } from 'chartjs-chart-funnel';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// register controller in chart.js and ensure the defaults are set
Chart.register(FunnelController, TrapezoidElement, zoomPlugin);

window.analitics = (params) => {
    moment.locale('ru');

    let timer = null
    let data = null
    let dateGrouping = 'day' // добавляем переменную для группировки

    let chartCalls = null
    let lineChartPoints = {}
    let chartDirections = null
    let chartObjection = null
    let chartObjectionResult = null
    let chartErrors = null
    let funnelChart = null

    let typeCalls = 'percent';

    const stages = params.stages

    const init = () => {
        event()
        handlerFilter()
    }


    const event = () => {
        // добавляем обработчик для группировки дат
        $("#date_from, #date_to, #first, #price, #signed, #directions, #subjects, #company, #admin, #dateGrouping").on('change', function () {
            clearTimeout(timer)

            timer = setTimeout(handlerFilter, 2000)
        })

        $('#typeCalls').on('change', function () {
            typeCalls = $(this).val()
            render()
        })

        // добавляем обработчик для переключателей datasets
        $("#dataset-toggle-line-chart").on('change', function() {

            const selectedValues = $(this).val() || [];
            for (let chartId in lineChartPoints) {
                let chart = lineChartPoints[chartId]
                chart.data.datasets.forEach((dataset, index) => {
                    console.log(selectedValues, dataset.label)
                    const isVisible = selectedValues.includes(dataset.label);
                    chart.setDatasetVisibility(index, isVisible);
                });
                chart.update();
            };
        });
    }

    const handlerFilter = () => {

        if (!$('#date_from').val() && $('#date_to').val()) {
            alert('Не выбраны даты')
        }

        $.post('analitics', {
            date_from: $('#date_from').val(),
            date_to: $('#date_to').val(),
            first: $('#first').val(),
            price: $('#price').val(),
            admin: $('#admin').val(),
            directions: $('#directions').val(),
            subjects: $('#subjects').val(),
            company: $('#company').val(),
            date_grouping: $('#dateGrouping').val()
        }, (result) => {
            data = result
            render()
        })
    }

    // обновляем функцию форматирования даты с учетом группировки
    const formatDate = (date, grouping = null) => {
        const currentGrouping = grouping || $('#dateGrouping').val() || 'day'

        if (date.length > 10) {
            switch(currentGrouping) {
                case 'week':
                    return 'Неделя ' + moment(date).format('WW.YYYY')
                case 'month':
                    return moment(date).format('MM.YYYY')
                case 'day':
                default:
                    return moment(date).format('DD.MM.YYYY HH:mm')
            }
        } else {
            switch(currentGrouping) {
                case 'week':
                    return 'Неделя ' + moment(date).format('WW.YYYY')
                case 'month':
                    return moment(date).format('MM.YYYY')
                case 'day':
                default:
                    return moment(date).format('DD.MM.YYYY')
            }
        }
    }



    const render = () => {
        renderChartCalls()

        renderChartDirections()

        renderChartErrors()

        renderChartObjection()

        renderChartObjectionResult()

        renderFunnelChart()

        $('#chartPoints').html('')
        if (data.points.length > 0) {

            let titleChartPoints = ''
            for (let stage in stages) {
                titleChartPoints += '<div class="col-1 chart-point-item">\n' +
                    '<div class="title">' + stages[stage] + '</div>' +
                    '</div>\n'
            }
            $('#chartPoints').append(
                '<div class="row analitic-chart-points__header">' +
                '<div class="col-12 p-3">' +
                '<div class="row">\n' +
                '<div class="col-1 chart-point-item">\n' +
                '<div class="title">Администратор</div>' +
                '</div>\n' +
                '<div class="col-1 chart-point-item">\n' +
                '<div class="title">Итоговая эффективность</div>' +
                '</div>\n' +
                titleChartPoints +
                '<div class="col-1 chart-point-item">\n' +
                '<div class="title">Рекомендации</div>' +
                '</div>\n' +
                '</div>' +
                '</div>' +
                '</div>'
            )
        }
        data.points.forEach((userPoints, key) => {
            if (key > 7) return
            if (!userPoints.userId) return

            const user = data.users.find(item => item.id === userPoints.userId)

            let valueChartPoints = ''
            for (let stage in stages) {
                valueChartPoints += '<div class="col-1 chart-point-item">\n' +
                    '<div class="canvas"><canvas id="chartPoints_'+stage+'_' + key + '" style="min-height: 70px; max-height: 70px"></canvas>\n' +
                    '<div class="percent"></div></div>' +
                    '</div>\n'
            }

            $('#chartPoints').append(
                '<div class="row">' +
                '<div class="col-12 callout callout-info">' +
                    '<a class="row align-items-center chart-point-row" href="/ii-call/record?date_from='+$('#date_from').val()+'&date_to='+$('#date_from').val()+'&admin='+user?.id+'&first=1" target="_blank">\n' +
                        '<div class="col-1">\n' +
                            '<p class="title">'+user?.name+'</p>\n' +
                        '</div>\n' +
                        '<div class="col-1 chart-point-item">\n' +
                        '<div class="canvas"><canvas id="chartPoints_total_' + key + '" style="min-height: 70px; max-height: 70px"></canvas>\n' +
                        '<div class="percent"></div></div>' +
                        '</div>\n' +
                        valueChartPoints +
                        '<div class="col-1 chart-point-item">\n' +
                            '<p class="title">'+user?.error+'</p>\n' +
                        '</div>\n' +
                    '</a>' +
                '</div>' +
                '</div>'
            )

            for (let stage in stages) {
                const length = userPoints.points.filter(item => stage in item.points).length
                if (length > 0) {
                    renderChartPoints('chartPoints_' + stage + '_' + key, userPoints.points.reduce((sum, item) => sum + (item.points[stage] ?? 0), 0) / length)
                }
            }
            const lengthTotal = userPoints.points.filter(item => 'total' in item.points).length
            if (lengthTotal > 0) {
                renderChartPoints('chartPoints_total_' + key, userPoints.points.reduce((sum, item) => sum + (item.points['total'] ?? 0), 0) / lengthTotal)
            }

        })

        $('#lineChartPoints').html('')
        data.points.forEach((userPoints, key) => {
            if (key > 7) return
            if (!userPoints.userId) return

            const userName = data.users.find(item => item.id === userPoints.userId)?.name

            $('#lineChartPoints').append(
                // '<div class="row">' +
                '<div class="col-md-6 col-12">' +
                '<div class="card">\n' +
                '<div class="card-header">\n' +
                '<h3 class="card-title">Эффективность администратора '+userName+'</h3>\n' +
                '</div>\n' +
                '<div class="card-body">\n' +
                '<div class="row">\n' +
                '<div class="col">\n' +
                '<canvas id="lineChartPoints_' + key + '" style="min-height: 300px; max-height: 500px"></canvas>\n' +
                '</div>\n' +
                '</div>\n' +
                '</div>\n' +
                '</div>' +
                '</div>'
                // '</div>'
            )

            renderLineChartPoints('lineChartPoints_' + key, userPoints.points)
        })

        if (data?.all?.all > 0) {
            $('.effects').html(Math.round(100 / data?.all?.all * data?.all?.signed) + '%');
        } else {
            $('.effects').html(0);
        }

    }

    const renderChartCalls = () => {
        const labels = data?.calls?.map(row => formatDate(row.date));
        const color = [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
        ]

        chartCalls?.destroy();

        chartCalls = new Chart(
            document.getElementById('chartCalls').getContext('2d'),
            {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: data?.users?.map((user, key) => {
                        return {
                            label: user.name,
                            data: data?.calls?.map(row => {
                                if (row.count[user.id]) {
                                    if (typeCalls === 'percent') {
                                        if (row.count[user.id].all > 0) {
                                            return Math.round(100 / row.count[user.id].all * row.count[user.id].count)
                                        } else {
                                            return 0
                                        }
                                    } else {
                                        return row.count[user.id].count
                                    }
                                } else {
                                    return 0
                                }
                            }),
                            borderColor: color[key],
                            backgroundColor: color[key],
                            borderWidth: 1,
                            fill: false,
                            cubicInterpolationMode: 'monotone',
                            tension: 0.4
                        }
                    }).concat([{
                        label: 'Не определен',
                        data: data?.calls?.map(row => {
                            if (row.count[""]) {
                                if (typeCalls === 'percent') {
                                    if (row.count[""].all > 0) {
                                        return Math.round(100 / row.count[""].all * row.count[""].count)
                                    } else {
                                        return 0
                                    }
                                } else {
                                    return row.count[""].count
                                }
                            } else {
                                return 0
                            }
                        }),
                        borderColor: 'rgb(255, 99, 132)',
                        backgroundColor: 'rgba(255, 99, 132,0.62)',
                        borderWidth: 1,
                        fill: false,
                        cubicInterpolationMode: 'monotone',
                        tension: 0.4
                    }]).concat([{
                        label: '📊 ОБЩИЙ ПОКАЗАТЕЛЬ',
                        data: data?.calls?.map(row => {
                            let totalCount = 0;
                            let totalAll = 0;
                            for (let userId in row.count) {
                                totalCount += row.count[userId].count || 0;
                                totalAll += row.count[userId].all || 0;
                            }
                            if (typeCalls === 'percent') {
                                return totalAll > 0 ? Math.round(totalCount / totalAll * 100) : 0;
                            } else {
                                return totalCount;
                            }
                        }),
                        borderColor: 'rgb(236,98,98)',
                        backgroundColor: 'rgb(236,98,98)',
                        borderWidth: 4,
                        fill: false,
                        cubicInterpolationMode: 'monotone',
                        tension: 0.4,
                        pointRadius: 6,
                        pointHoverRadius: 8,
                        pointBackgroundColor: 'rgb(255, 215, 0)',
                        pointBorderColor: 'rgb(0, 0, 0)',
                        pointBorderWidth: 2
                    }]),
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    plugins: {
                        datalabels: {
                            backgroundColor: function(context) {
                                return context.dataset.backgroundColor;
                            },
                            borderRadius: 4,
                            color: 'white',
                            font: {
                                weight: 'bold'
                            },
                            formatter: Math.round,
                            padding: 6
                        },
                        legend: {
                            position: 'bottom',
                        }
                    }
                },
                plugins: [ChartDataLabels]
            }
        )
    }

    const renderChartDirections = () => {
        chartDirections?.destroy();

        chartDirections = new Chart(
            document.getElementById('chartDirections').getContext('2d'),
            {
                type: 'pie',
                data: {
                    labels: data?.directions?.map(row => row.name),
                    datasets: [
                        {
                            label: 'Количество',
                            data: data?.directions?.map(row => row.count),
                            backgroundColor: [
                                'rgb(255, 99, 132)',
                                'rgb(255, 159, 64)',
                                'rgb(255, 205, 86)',
                                'rgb(75, 192, 192)',
                                'rgb(54, 162, 235)',
                                'rgb(153, 102, 255)',
                                'rgb(201, 203, 207)'
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    plugins: {
                        datalabels: {
                            anchor: 'center',
                            backgroundColor: function(context) {
                                return context.dataset.backgroundColor;
                            },
                            borderColor: 'white',
                            borderRadius: 25,
                            borderWidth: 2,
                            color: 'white',
                            font: {
                                weight: 'bold'
                            },
                            formatter: Math.round,
                            padding: 6,
                        },
                        legend: {
                            position: 'bottom',
                        }
                    },
                    onClick: (event, elements) => {
                        const index = elements[0].index;

                        let filter = {
                            date_from: $('#date_from').val(),
                            date_to: $('#date_to').val(),
                            first: 1,
                            price: 1,
                            firstOrPrice: 1,
                            admin: $('#admin').val(),
                            directions: data?.directions[index].id,
                            subjects: $('#subjects').val(),
                            company: $('#company').val(),
                        }

                        if ($('#first').val() || $('#price').val()) {
                            filter.first = $('#first').val();
                            filter.price = $('#price').val();
                            filter.firstOrPrice = 0
                        }

                        window.open(`/ii-call/record?${$.param(filter)}`, '_blank');
                    }
                },
                plugins: [ChartDataLabels]
            }
        )
    }

    const renderChartObjection = () => {
        chartObjection?.destroy();

        chartObjection = new Chart(
            document.getElementById('chartObjection').getContext('2d'),
            {
                type: 'pie',
                data: {
                    labels: data?.objections?.type?.map(row => row.name),
                    datasets: [
                        {
                            label: 'Количество',
                            data: data?.objections?.type?.map(row => row.count),
                            backgroundColor: [
                                'rgb(255, 99, 132)',
                                'rgb(255, 159, 64)',
                                'rgb(255, 205, 86)',
                                'rgb(75, 192, 192)',
                                'rgb(54, 162, 235)',
                                'rgb(153, 102, 255)',
                                'rgb(201, 203, 207)'
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    plugins: {
                        datalabels: {
                            anchor: 'center',
                            backgroundColor: function(context) {
                                return context.dataset.backgroundColor;
                            },
                            borderColor: 'white',
                            borderRadius: 25,
                            borderWidth: 2,
                            color: 'white',
                            font: {
                                weight: 'bold'
                            },
                            formatter: Math.round,
                            padding: 6,
                        },
                        legend: {
                            position: 'bottom',
                        }
                    },
                    onClick: (event, elements) => {
                        const index = elements[0].index;

                        let filter = {
                            date_from: $('#date_from').val(),
                            date_to: $('#date_to').val(),
                            first: 1,
                            price: 1,
                            firstOrPrice: 1,
                            objection: data?.objections?.type[index].key,
                            company: $('#company').val(),
                        }

                        if ($('#first').val() || $('#price').val()) {
                            filter.first = $('#first').val();
                            filter.price = $('#price').val();
                            filter.firstOrPrice = 0
                        }

                        window.open(`/ii-call/record?${$.param(filter)}`, '_blank');
                    }
                },
                plugins: [ChartDataLabels]
            }
        )
    }

    const renderChartObjectionResult = () => {
        chartObjectionResult?.destroy();

        chartObjectionResult = new Chart(
            document.getElementById('chartObjectionResult').getContext('2d'),
            {
                type: 'pie',
                data: {
                    labels: ['Отработаны', 'Не отработаны'],
                    datasets: [
                        {
                            label: 'Количество',
                            data: [
                                data?.objections?.result?.success,
                                data?.objections?.result?.fail
                            ],
                            backgroundColor: [
                                'rgb(255, 99, 132)',
                                'rgb(255, 159, 64)',
                                'rgb(255, 205, 86)',
                                'rgb(75, 192, 192)',
                                'rgb(54, 162, 235)',
                                'rgb(153, 102, 255)',
                                'rgb(201, 203, 207)'
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    plugins: {
                        datalabels: {
                            anchor: 'center',
                            backgroundColor: function(context) {
                                return context.dataset.backgroundColor;
                            },
                            borderColor: 'white',
                            borderRadius: 25,
                            borderWidth: 2,
                            color: 'white',
                            font: {
                                weight: 'bold'
                            },
                            formatter: Math.round,
                            padding: 6,
                        },
                        legend: {
                            position: 'bottom',
                        }
                    },
                    onClick: (event, elements) => {
                        const index = elements[0].index;

                        let filter = {
                            date_from: $('#date_from').val(),
                            date_to: $('#date_to').val(),
                            first: 1,
                            price: 1,
                            firstOrPrice: 1,
                            objection_result: index === 0 ? 1 : 0,
                            company: $('#company').val(),
                        }

                        if ($('#first').val() || $('#price').val()) {
                            filter.first = $('#first').val();
                            filter.price = $('#price').val();
                            filter.firstOrPrice = 0
                        }

                        window.open(`/ii-call/record?${$.param(filter)}`, '_blank');
                    }
                },
                plugins: [ChartDataLabels]
            }
        )
    }

    const renderChartErrors = () => {
        chartErrors?.destroy();

        const sumErrors = data?.errors?.reduce((a, b) => a + b.count, 0)

        chartErrors = new Chart(
            document.getElementById('chartErrors').getContext('2d'),
            {
                type: 'pie',
                data: {
                    labels: data?.errors?.map(row => row.name),
                    datasets: [
                        {
                            label: 'Процент',
                            data: data?.errors?.map(row => Math.ceil(row.count / sumErrors * 100)),
                            backgroundColor: [
                                'rgb(255, 99, 132)',
                                'rgb(255, 159, 64)',
                                'rgb(255, 205, 86)',
                                'rgb(75, 192, 192)',
                                'rgb(54, 162, 235)',
                                'rgb(153, 102, 255)',
                                'rgb(201, 203, 207)'
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    plugins: {
                        datalabels: {
                            anchor: 'center',
                            backgroundColor: function(context) {
                                return context.dataset.backgroundColor;
                            },
                            borderColor: 'white',
                            borderRadius: 25,
                            borderWidth: 2,
                            color: 'white',
                            font: {
                                weight: 'bold'
                            },
                            formatter: Math.round,
                            padding: 6
                        },
                        legend: {
                            position: 'bottom',
                        }
                    },
                    onClick: (event, elements) => {
                        const index = elements[0].index;

                        let filter = {
                            date_from: $('#date_from').val(),
                            date_to: $('#date_to').val(),
                            first: 1,
                            price: 1,
                            firstOrPrice: 1,
                            error: data?.errors[index].key,
                            company: $('#company').val(),
                        }

                        if ($('#first').val() || $('#price').val()) {
                            filter.first = $('#first').val();
                            filter.price = $('#price').val();
                            filter.firstOrPrice = 0
                        }

                        window.open(`/ii-call/record?${$.param(filter)}`, '_blank');
                    }
                },
                plugins: [ChartDataLabels]

            }
        )
    }

    const renderFunnelChart = () => {
        funnelChart?.destroy();
        funnelChart = new Chart(
            document.getElementById('chartFunnel').getContext('2d'),
            {
                type: 'funnel',
                data: {
                    labels: ['Всего звонков', 'Записались', ''],
                    datasets: [{
                        label: 'Количество',
                        data: [
                            data?.all?.all,
                            data?.all?.signed,
                            // 100 / data?.all?.all * data?.all?.signed
                        ],
                        shrinkAnchor: 'bottom',
                        backgroundColor: ['#457de6', '#ab71cb', '#fff']
                    }]
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    indexAxis: 'y',
                    plugins: {
                        datalabels: {
                            formatter: function(value, context) {
                                // if (context.dataIndex === 2) {
                                //     return value + '%';
                                // }
                            }
                        },
                        legend: {
                            position: 'bottom',
                        }
                    },
                    onClick: (event, elements) => {
                        const index = elements[0].index;
                        let filter = {
                            date_from: $('#date_from').val(),
                            date_to: $('#date_to').val(),
                            first: 1,
                            price: 1,
                            firstOrPrice: 1,
                            admin: $('#admin').val(),
                            directions: $('#directions').val(),
                            subjects: $('#subjects').val(),
                            company: $('#company').val(),
                        }
                        if ($('#first').val() || $('#price').val()) {
                            filter.first = $('#first').val();
                            filter.price = $('#price').val();
                            filter.firstOrPrice = 0
                        }

                        if (index !== 0) {
                            filter.signed = 1
                        }

                        window.open(`/ii-call/record?${$.param(filter)}`, '_blank');
                    }
                },
                plugins: [ChartDataLabels]
            }
        );
    }

    const renderLineChartPoints = (elementId, points) => {
        const labels = points?.map(row => formatDate(row.date));
        const pointLabels = Object.keys(data?.pointLabels)
        const color = [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
        ]

        lineChartPoints[elementId]?.destroy();

        lineChartPoints[elementId] = new Chart(
            document.getElementById(elementId).getContext('2d'),
            {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: pointLabels.map((label, key) => {
                        return {
                            label: data?.pointLabels[label],
                            data: points?.map(point => {
                                return point.points[label]
                            }),
                            borderColor: color[key],
                            backgroundColor: color[key],
                            borderWidth: 1,
                            fill: false,
                            cubicInterpolationMode: 'monotone',
                            tension: 0.4,
                            hidden: false
                        }
                    })
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    plugins: {
                        datalabels: {
                            backgroundColor: function(context) {
                                return context.dataset.backgroundColor;
                            },
                            borderRadius: 4,
                            color: 'white',
                            font: {
                                weight: 'bold'
                            },
                            formatter: Math.round,
                            padding: 6
                        },
                        legend: {
                            position: 'bottom',
                        }
                    }
                },
                plugins: [ChartDataLabels]
            }
        )
    }

    const renderChartPoints = (elementId, value) => {

        value = Math.min(value, 100);
        value = Math.round(value);

        if (isNaN(value)) {
            return;
        }

        $('#' + elementId).next().html(value + '%');

        chartPoints[elementId]?.destroy();

        chartPoints[elementId] = new Chart(
            document.getElementById(elementId).getContext('2d'),
            {
                type: 'doughnut',
                data: {
                    datasets: [
                        {
                            data: [value, 100 - value],
                            backgroundColor: [
                                value > 50 ? 'rgb(75, 192, 192)' : 'rgb(255, 99, 132)',
                                'rgb(201, 203, 207)'
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    plugins: {
                        legend: { display: false },
                        tooltip: { enabled: false }
                    }
                },
            }
        )
    }

    init()
}
